import { getService } from "../../reducers/service";
import { serviceNames } from "../../utils/constants";

export const getEquipmentOptions = async (userAgency) => {
	const service = await getService(serviceNames.perEquipment);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
			$limit: -1,
		},
	});

	const equipment = response?.data || response || [];

	return equipment.map((eq) => ({
		label: [
			eq.type,
			eq.brand,
			eq.model,
			"·",
			eq.serialNumber,
			eq.propertyNumber ? `(${eq.propertyNumber})` : "",
		]
			.filter(Boolean)
			.join(" "),
		value: eq.id,
		...eq,
	}));
};

export const getPerformedByOptions = async (userAgency) => {
	const service = await getService(serviceNames.perEquipmentMaintenance);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
			$limit: -1,
		},
	});

	const records = response?.data || response || [];
	const performers = [
		...new Set(records.map((r) => r.performedBy).filter(Boolean)),
	];

	return performers.map((p) => ({
		label: String(p),
		value: p,
	}));
};
